import axios from "axios";

class AuthService {

    constructor(httpClient) {
        this.httpClient = httpClient;
    }

async login(body) {
    const baseURL = process.env.REACT_APP_API_URL;
    const payload = {
        email: body?.email?.trim()?.toLowerCase(),
        password: body?.password ?? '',
    };
    return await axios.post(`${baseURL}/auth/login`, payload);
}

async register(body) {
    const payload = {
        email: body?.email?.trim()?.toLowerCase(),
        password: body?.password ?? '',
        status: body?.status ?? 'vendor',
    };
    return await this.httpClient.post('/auth/register', payload);
}

async findUserByToken() {
    return await this.httpClient.get(`/auth/findByToken`);
}



}

export default AuthService;
